export default {
	required: v => !!v || '값을 입력해주세요.',
};
